import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

export const TableWarehouseItemsCell: TableValueCellComponent = ({ value }) => {
  const warehouseItems = value || {};
  const warehouseItemsArray = Object.entries(warehouseItems).map(
    ([itemId, itemData]: [string, any]) => ({
      itemId,
      name: itemData?.name || itemId,
      quantity: itemData?.quantity || 0,
    }),
  );

  if (warehouseItemsArray.length === 0) {
    return <DataTable.Cell>-</DataTable.Cell>;
  }

  return (
    <DataTable.Cell>
      {warehouseItemsArray
        .map((item) => `${item.name} (x${item.quantity})`)
        .join(", ")}
    </DataTable.Cell>
  );
};
